import type { Action } from 'redux';
import NotificationActions from '../../../../main/actions/NotificationActions';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const FetchAdLinkCollections = new ReduxAsyncAction<'FETCH_AD_LINK_COLLECTIONS', void, any>('FETCH_AD_LINK_COLLECTIONS');

FetchAdLinkCollections.registerRequest(async () => {
  try {
    const response = await dash_api.get('/v1/linkhub/collections?type=ad');

    return { adLinkCollections: response?.data };
  } catch (error) {
    NotificationActions.showNotification('Failed to fetch ad link collections.', 'error');

    throw error;
  }
});

export const FETCH_AD_LINK_COLLECTIONS = FetchAdLinkCollections.actionNamespaceConstants;

export const fetchAdLinkCollections = FetchAdLinkCollections.request;

export type FetchAdLinkCollectionsResponseAction = Action<typeof FETCH_AD_LINK_COLLECTIONS.response> & {
  data: any;
};
